import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card, CardBody, Badge, Button, Table, Progress, Input } from "reactstrap";
import "../../assets/css/--page-order-history.css";
import { useNavigate } from "react-router-dom";
import { getOrderlist, formatDate, addCartReOrder } from "../../helper/backend-methods";
import reOrderIcon from "../../assets/images/Reorder.png";
import noOrder from "../../assets/images/no-order.png";
import AppLoader from "../../components/AppLoader";
import { customToast } from "../../components/customToast";

function OrderHistory(props) {
  const history = useNavigate();
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(true);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [search, setSearch] = useState("");
  const [orderedProducts, setOrderedProducts] = useState([]);
  const [_orderedProducts, _setOrderedProducts] = useState([]);
  const [orderStatus, setOrderStatus] = useState("");

  const [showStatusDropdown, setShowStatusDropdown] = useState(false);

  const statusOptions = [
    { label: "Filter by Status (All)", value: "" },
    { label: "Ready For Pickup", value: "Ready For Pickup" },
    { label: "Delivered", value: "Order Picked Up" },
    { label: "Cancelled", value: "Cancelled" },
    { label: "Rejected", value: "Rejected" },
    { label: "Preparing", value: "Preparing" },
  ];

  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowStatusDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleExpand = (id) => {
    setExpandedOrder(expandedOrder === id ? null : id);
  };
  // handle input change
  const handleChange = (event) => {
    const newSearch = event.target.value;
    setSearch(newSearch);
    const filteredOrders = getOrderFiltered(newSearch);
    setOrderedProducts(filteredOrders);
  };

  const getOrders = () => {
    setLoading(true);
    getOrderlist({ orderStatus: orderStatus || "all" })
      .then(({ data }) => {
        if (data.Status) {
          data.Data.OrderList.map((o) => {
            o.OrderDate = formatDate(o.OrderDate);
            return o;
          });
          _setOrderedProducts(data.Data.OrderList);
          setOrderedProducts(getOrderFiltered(search, data.Data.OrderList));
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const getOrderFiltered = (_search, _list = _orderedProducts) => {
    if (!_search) {
      return _list;
    }
    var data = _list.filter((order) => {
      const orderNoMatch = order.OrderNo.toLowerCase().includes(_search.toLowerCase());
      const productMatch = order.productOrderDTO.some((item) => item.ProductName.toLowerCase().includes(_search.toLowerCase()));
      return orderNoMatch || productMatch;
    });
    return data;
  };

  const reOrder = (_order) => {
    addCartReOrder({ OrderId: _order.OrderId })
      .then(({ data }) => {
        if (data.Status) {
          customToast.success("", data.Message, "/openCart");
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
  };
  useEffect(() => {
    getOrders();
  }, [orderStatus]);

  return (
    <div id="order-history-page" className="mt-5 ms-4">
      <div className="order-heading d-flex align-items-center mb-4 grill-title-box">
        <h1 className="fs-30 text-blakish fw-600 m-0 main-title">Order History</h1>
      </div>
      <span className="separator mt-4 mb-3"></span>

      <div className="order-toolbar mb-4">
        <div className="search-box">
          <i className="ri-search-line"></i>
          <input
            value={search}
            onChange={handleChange} // update on change
            type="text"
            placeholder="Search orders or dishes..."
            className="search-input"
          />
        </div>
        <div className="custom-dd-wrapper" ref={wrapperRef}>
          <div className="custom-dd-selected" onClick={() => setShowStatusDropdown((prev) => !prev)}>
            {statusOptions.find((o) => o.value === orderStatus)?.label}
            <i className="ri-arrow-down-s-line custom-dd-arrow"></i>
          </div>

          {showStatusDropdown && (
            <div className="custom-dd-menu">
              {statusOptions.map((option) => (
                <div
                  key={option.value}
                  className={`custom-dd-item ${orderStatus === option.value ? "active" : ""}`}
                  onClick={() => {
                    setOrderStatus(option.value);
                    setShowStatusDropdown(false);
                  }}
                >
                  <span className={option.label === "Cancelled" ? "cancel-text" : ""}>{option.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="order-history-container" style={{ maxWidth: orderedProducts.length ? "" : "100%" }}>
        {orderedProducts.length ? (
          <div className="order-history-inner">
            {orderedProducts.map((order) => (
              <div key={order.OrderNo} className="order-toggle mb-3 bg-white" onClick={() => toggleExpand(order.OrderNo)}>
                <CardBody>
                  <Row className="history-container">
                    <Col md={3}>
                      <div className="fw-600 text-black fs-18">Order No.</div>
                      <div className="text-gray fs-18">#{order.OrderNo}</div>
                    </Col>
                    <Col md={3}>
                      <div className="fw-600 text-black fs-18">Date & Time</div>
                      <div className="text-gray fs-16">{order.OrderDate}</div>
                    </Col>
                    <Col md={3}>
                      <div className="fw-600 text-black fs-18">Status</div>
                      <span className={`status-badge ${order.CurrentStatus.toLowerCase().replace(/ /g, "")}`}>
                        {order.CurrentStatus.toLowerCase() === "order picked up" ? "Delivered" : order.CurrentStatus}
                      </span>
                    </Col>
                    <Col md={3} className="text-end align-items-center reorcer-container">
                      <div className="d-flex align-items-center justify-content-end">
                        <button color="primary" className="reorder-btn me-2 d-flex align-items-center gap-1" onClick={() => reOrder(order)}>
                          <img src={reOrderIcon} alt="Reorder" /> REORDER
                        </button>
                        <span className="p-0 toggle-btn cursor-pointer" onClick={() => toggleExpand(order.OrderNo)}>
                          {expandedOrder === order.OrderNo ? (
                            <i className="ri-arrow-up-s-line fs-30 fw-400 text-gray"></i>
                          ) : (
                            <i className="ri-arrow-down-s-line fs-30 fw-400 text-gray"></i>
                          )}
                        </span>
                      </div>
                    </Col>
                  </Row>

                  {expandedOrder === order.OrderNo && (
                    <div className="order-details mt-3 pt-3 border-top">
                      <div className="fw-600 fs-18 text-black mb-2">Order Details</div>
                      {order.productOrderDTO.map((item, i) => (
                        <div
                          key={i}
                          className={`d-flex justify-content-between text-gray py-3 fs-18 ${order.productOrderDTO.length === i + 1 ? "" : "border-dotted"}`}
                        >
                          <span>
                            {item.Quantity} x {item.ProductName}
                          </span>
                          <span>${item.Total.toFixed(2)}</span>
                        </div>
                      ))}
                      <span className="separator mt-0 mb-0"></span>
                      <div className="d-flex justify-content-between mt-3 fw-600">
                        <span className="fs-18 text-gray">Sub Total</span>
                        <span className="fs-18 text-blakish">${order.SubTotal}</span>
                      </div>
                      <div className="d-flex justify-content-between mt-3 fw-600">
                        <span className="fs-18 text-gray">Tax 15%</span>
                        <span className="fs-18 text-blakish">${order.OrderTaxTotal}</span>
                      </div>
                      <span className="separator mt-3 mb-3"></span>
                      <div className="d-flex justify-content-between mt-2 fw-600">
                        <span className="fs-20 text-blakish">Grand Total</span>
                        <span className="fs-20 text-blakish">${order.TotalAmount.toFixed(2)}</span>
                      </div>
                    </div>
                  )}
                </CardBody>
              </div>
            ))}
          </div>
        ) : loading ? (
          <div className="loader-center">
            <AppLoader />
          </div>
        ) : search ? (
          <div className="d-flex flex-column justify-content-center align-items-center flex-wrap text-center mt-5 pt-5">
            <img src={noOrder} alt="" />
            <h2 className="fs-36 fw-600 text-blakish mt-4">No Orders Found</h2>
            <p className="fs-18 fw-600 text-blakish mt-2">
              We couldn't find any orders matching "{search}".
            </p>
          </div>
        ) : (
          <div className="d-flex flex-column justify-content-center align-items-center flex-wrap text-center mt-5 pt-5">
            <img src={noOrder} alt="" />

            <h2 className="fs-36 fw-600 text-blakish mt-4">
              {orderStatus === "Cancelled" ? (
                "No Cancelled Orders Found"
              ) : orderStatus === "Rejected" ? (
                "No Rejected Orders Found"
              ) : orderStatus === "Order Picked Up" ? (
                "No Delivered Orders Found"
              ) : (
                <>
                  Looks Like You Haven't <br />
                  Ordered Before
                </>
              )}
            </h2>

            <p className="fs-18 fw-600 text-blakish mt-2">
              {orderStatus ? (
                "Orders with this status will appear here once available."
              ) : (
                <>
                  Once you place an order, it will show up here for easy reordering <br /> and quick access.
                </>
              )}
            </p>

            {!orderStatus && (
              <button className="explore-menu-btn mt-3" onClick={() => history("/menu")}>
                START YOUR FIRST ORDER
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderHistory;
